import { createContext } from 'react'

const communicationContext = createContext()

export default communicationContext
